import { Layout } from 'antd';
import '../../styles/layouts/footer.css';

const { Footer } = Layout;
const FooterComponent = () => {
    return (
        <Footer className='footer'>
            MRYY ©2023 Created by Rizky Yusfian
        </Footer>
    );
};
export default FooterComponent;